module.exports = __webpack_public_path__ + "static/img/task1.b49fccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/workbench/img/task1.png
// module id = kLQA
// module chunks = 3